'use client';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { CheckIcon, InfoIcon, WarningIcon } from "./chunk-NEDBTDT2.mjs"; // src/alert-context.ts

import { createContext } from "@chakra-ui/react-context";
import { Spinner } from "@chakra-ui/spinner";

var _createContext = createContext({
  name: "AlertContext",
  hookName: "useAlertContext",
  providerName: "<Alert />"
}),
    _createContext2 = _slicedToArray(_createContext, 2),
    AlertProvider = _createContext2[0],
    useAlertContext = _createContext2[1];

var _createContext3 = createContext({
  name: "AlertStylesContext",
  hookName: "useAlertStyles",
  providerName: "<Alert />"
}),
    _createContext4 = _slicedToArray(_createContext3, 2),
    AlertStylesProvider = _createContext4[0],
    useAlertStyles = _createContext4[1];

var STATUSES = {
  info: {
    icon: InfoIcon,
    colorScheme: "blue"
  },
  warning: {
    icon: WarningIcon,
    colorScheme: "orange"
  },
  success: {
    icon: CheckIcon,
    colorScheme: "green"
  },
  error: {
    icon: WarningIcon,
    colorScheme: "red"
  },
  loading: {
    icon: Spinner,
    colorScheme: "blue"
  }
};

function getStatusColorScheme(status) {
  return STATUSES[status].colorScheme;
}

function getStatusIcon(status) {
  return STATUSES[status].icon;
}

export { AlertProvider, useAlertContext, AlertStylesProvider, useAlertStyles, getStatusColorScheme, getStatusIcon };